import React, { useEffect, useState } from 'react';
import './startTradingNowSection.scss';
import { ReactComponent as StartTradingNowIcon } from "./icons/StartTradingNowIcon.svg";
import StartTradingNowLinkComponent from "./components/StartTradingNowLinkComponent";
import { ReactComponent as SolanaIcon } from "./icons/SolanaIcon.svg";
import { ReactComponent as TronIcon } from "./icons/TronIcon.svg";
import { ReactComponent as ApeIcon } from "./icons/ApeIcon.svg";
import { ReactComponent as SuiIcon } from "./icons/SuiIcon.svg";

import { ReactComponent as BaseIcon } from "./icons/BaseIcon.svg";
import { ReactComponent as XRPIcon } from "./icons/XRPIcon.svg";
import { ReactComponent as BNBIcon } from "./icons/BNBIcon.svg";

import { ReactComponent as BeraIcon } from "./icons/BeraIcon.svg";
import { ReactComponent as AptosIcon } from "./icons/AptosIcon.svg";

const StartTradingNowSection = () => {
	const [isHoveredSolana, setIsHoveredSolana] = useState(false);
	const [isHoveredAptos, setIsHoveredAptos] = useState(false);
	
	return (
		<div id='startTradingNow' className="startTradingNow">
			<div className="startTradingNow__content">
				<div className="startTradingNow__content_title">
					<div className="startTradingNow__content_title_row">
						<h3>Start</h3>
						<StartTradingNowIcon />
						<h3>trading</h3>
					</div>
					<div className="startTradingNow__content_title_row">
						<h3>right now</h3>
					</div>
				</div>
				<div className="startTradingNow__content_links">
					<div className="startTradingNow__content_links_row">
						<StartTradingNowLinkComponent
							icon={<TronIcon />}
							class={"tron"}
							title={"Trade on Tron"}
							link={"https://t.me/nfd_tron_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
						<StartTradingNowLinkComponent
							icon={<ApeIcon />}
							class={"ape"}
							title={"Trade on APE"}
							link={"https://t.me/nfd_ape_chain_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
						<StartTradingNowLinkComponent
							icon={<SuiIcon />}
							class={"sui"}
							title={"Trade on Sui"}
							link={"https://t.me/nfd_sui_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
					</div>
					<div className="startTradingNow__content_links_row">
						<StartTradingNowLinkComponent
							icon={<BaseIcon />}
							class={"base"}
							title={"Trade on Base"}
							link={"https://t.me/nfd_base_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
						<StartTradingNowLinkComponent
							icon={<XRPIcon />}
							class={"xrp"}
							title={"Trade on XRP"}
							link={"https://t.me/nfd_ripple_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
						<StartTradingNowLinkComponent
							icon={<BNBIcon />}
							class={"bnb"}
							title={"Trade on BNB"}
							link={"https://t.me/nfd_bep20_trade_bot"}
							withArrow={true}
							setIsHovered={() => {}}
						/>
					</div>
					<div className="startTradingNow__content_links_row">
						<StartTradingNowLinkComponent
							icon={<BeraIcon />}
							class={"bera"}
							title={"Trade on Bera"}
							link={""}
							withArrow={true}
							setIsHovered={() => {}}
						/>
						<StartTradingNowLinkComponent
							icon={<SolanaIcon />}
							class={"solana"}
							title={"Trade on Solana"}
							link={""}
							withArrow={true}
							soonText={"Solana coming soon"}
							isHovered={isHoveredSolana}
							setIsHovered={setIsHoveredSolana}
						/>
						<StartTradingNowLinkComponent
							icon={<AptosIcon />}
							class={"aptos"}
							title={"Trade on Aptos"}
							link={""}
							withArrow={true}
							soonText={"Aptos coming soon"}
							isHovered={isHoveredAptos}
							setIsHovered={setIsHoveredAptos}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default StartTradingNowSection;